import { render, staticRenderFns } from "./info-table.vue?vue&type=template&id=bdc73bac&"
import script from "./info-table.vue?vue&type=script&lang=js&"
export * from "./info-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports